@if (risk) {
    @if (isLoading) {
        <div class="fancy-loader"></div>
    } @else {
        <thirdparty-linkable
            #linkableThirdParty
            typename="third party"
            displayValueProp="name"
            [linked]="linked"
            [unlinked]="[]"
            [orderByValueProperty]="true"
            [disabled]="true"
        >
        </thirdparty-linkable>
    }
}
